import * as sass from "./lists.module.scss"

const NoteUl = ({ children }) => {
  return <ul className={sass.bookList}>{children}</ul>
}

export default NoteUl
